import Vue from 'vue'
import { uuid } from 'vue-uuid'
import { ADD_TOAST_MESSAGE, REMOVE_TOAST_MESSAGE } from 'vuex-toast'
import MessageStatus from '../../helper/messageTypes'

export const SET_CONNECTING_SOCKET = 'SET_CONNECTING_SOCKET'
export const SET_AUTHENTICATED_SOCKET = 'SET_AUTHENTICATED_SOCKET'
export const CLEAR_SOCKETIO_STORE = 'CLEAR_SOCKETIO_STORE'

const state = {
  isConnecting: false,
  isAuthenticated: false
}

const getters = {
  getterIsConnectingSocket: (state) => state.isConnecting,
  getterIsAuthenticated: (state) => state.isAuthenticated
}

const mutations = {
  [SET_CONNECTING_SOCKET] (state, value) {
    state.isConnecting = value
  },
  [SET_AUTHENTICATED_SOCKET] (state, value) {
    state.isAuthenticated = value
  },
  [CLEAR_SOCKETIO_STORE] (state) {
    state.isConnecting = false
    state.isAuthenticated = false
  }
}

const actions = {
  socket_disconnect ({ commit }) {
    commit(SET_CONNECTING_SOCKET, false)
    commit(CLEAR_SOCKETIO_STORE)
  },
  socket_reconnect ({ commit }) {
    commit(SET_AUTHENTICATED_SOCKET, false)

    commit('SET_GENERIC_EVENTS', {
      key: 'IsWritingLoading',
      value: false
    })
  },
  socket_unauthorized ({ dispatch, commit }) {
    dispatch(ADD_TOAST_MESSAGE, {
      text: 'Você não está autorizado a acessar este bot, por favor entre em contato com o suporte!',
      type: 'danger',
      dismissAfter: 60000
    })

    dispatch('actionGlobalDisconnect')

    commit('SET_GENERIC_EVENTS', {
      key: 'IsWritingLoading',
      value: false
    })
  },
  socket_connect_error ({ dispatch, commit }) {
    dispatch(ADD_TOAST_MESSAGE, {
      text: 'Erro ao connectar no socket, por favor tente novamente mais tarde!',
      type: 'danger',
      dismissAfter: 6000
    })

    dispatch('actionGlobalDisconnect')

    commit('SET_GENERIC_EVENTS', {
      key: 'IsWritingLoading',
      value: true
    })
  },
  socket_error ({ dispatch, commit }) {
    for (let i = 0; i < 100; i++) {
      dispatch(REMOVE_TOAST_MESSAGE, i)
    }

    dispatch(ADD_TOAST_MESSAGE, {
      text: 'Erro ao enviar mensagem, por favor tente novamente!',
      type: 'danger',
      dismissAfter: 6000
    })

    commit('SET_GENERIC_EVENTS', {
      key: 'IsWritingLoading',
      value: true
    })
  },
  socket_connect ({ getters, commit }) {
    const authenticationAndConnect = !getters.getterIsAuthenticated && !getters.getterIsConnectingSocket
    const botIdUserId = getters.getterSettingWebchat.botId && getters.getterSettingWebchat.botId.length && getters.getterSettingWebchat.userId && getters.getterSettingWebchat.userId.length

    if (authenticationAndConnect && botIdUserId) {
      commit(SET_CONNECTING_SOCKET, true)
      const data = {
        botId: getters.getterSettingWebchat.botId,
        userId: getters.getterSettingWebchat.userId,
        conversationId: getters.getterSettingWebchat.conversationId
      }

      if (!data.conversationId) {
        data.conversationId = data.userId

        commit('SET_SETTINGS_WEBCHAT', { ...getters.getterSettingWebchat, conversationId: data.conversationId })
      }

      Vue.prototype.$socket.client.emit('authentication', data)

      commit('SET_GENERIC_EVENTS', {
        key: 'IsWritingLoading',
        value: false
      })
    } else {
      commit(CLEAR_SOCKETIO_STORE)
    }
  },
  socket_authenticated ({ getters, commit }) {
    commit(SET_CONNECTING_SOCKET, false)
    commit(SET_AUTHENTICATED_SOCKET, true)

    if (getters.getterSettingWebchat.conversationId) {
      Vue.prototype.$socket.client.emit(
        'check_cache_messages',
        getters.getterSettingWebchat.conversationId
      )
    }
  },
  socket_message ({ commit }, params) {
    const isSacContext = params.conversationContext && params.conversationContext.route === 'attendance'
    commit('$mutationIsSacContext', isSacContext)
    commit('IS_PLAY_SOUND')

    if (params.replies) {
      commit('$mutationConversationIsDebugger', {
        intent: params.intent,
        score: params.intentScore,
        isSacContext
      })
      params.replies.forEach(resource => {
        if (
          (resource.resourceType === 'text' && resource.text.trim().length > 0)
          || resource.resourceType === 'image'
          || resource.resourceType === 'file'
          || resource.resourceType === 'carousel'
          || resource.resourceType === 'menu'
          || resource.resourceType === 'audio'
          || resource.resourceType === 'video'
        ) {
          commit('$mutationIsBotResponse', false)
          commit('$mutationConversation', {
            id: uuid.v4(),
            text: resource.text,
            name: resource.imageName,
            resourceType: resource.resourceType,
            type: resource.type,
            url: resource.url,
            color: '#fff',
            userType: 'reply',
            msgTooltip: 'success',
            date: new Date().toISOString(),
            status: MessageStatus.SUCCESS,
            cards: resource.cards,
            isSacContext
          })
        } else {
          console.warn('RESOURCE_NOT_ALLOWED', resource)
        }
      })

      window.VLibras.Widget.ReloadTagsTexts()
    }

    commit('SET_GENERIC_EVENTS', {
      key: 'IsWritingLoading',
      value: false
    })
  },
  actionEmitMessage ({ getters, dispatch }, data) {
    const isEmpty = !data.userId || !data.conversationId || !data.username
    const newUserId = `${Vue.prototype.$globalRouter.currentRoute.params.botId}::${uuid.v4()}`
    const newConversationId = `${Vue.prototype.$globalRouter.currentRoute.query.activeTab}_${newUserId}`

    data.userId = isEmpty ? newUserId : data.userId
    data.conversationId = isEmpty ? newConversationId : data.conversationId
    data.username = isEmpty ? 'Usuário' : data.username

    let newSettings = {
      ...getters.getterSettingWebchat,
      lastMessage: new Date()
    }

    if (isEmpty) {
      newSettings = {
        ...newSettings,
        username: data.username,
        userId: data.userId,
        conversationId: data.conversationId,
        botId: data.botId
      }

      dispatch('actionSetLocalForageUserId', data.userId)
    }

    Vue.prototype.$eventBus.$emit('update-settings', newSettings)

    Vue.prototype.$socket.client.emit('message', data, (err, success) => {
      if (err) {
        console.error(err)
        const objMessage = {
          id: err.message.id,
          userType: 'message',
          isLoading: false,
          status: MessageStatus.ERROR
        }
        dispatch('$actionUpdateMessage', objMessage)
      } else {
        const objMessage = {
          id: success.message.id,
          userType: success.message.type,
          isLoading: false,
          status: MessageStatus.SUCCESS
        }
        dispatch('$actionUpdateMessage', objMessage)
      }
    })
  },
  actionEmitUploadFile ({ dispatch }, data) {
    Vue.prototype.$socket.client.emit('upload_file', data, (err, success) => {
      if (err) {
        console.error(err)
        const objMessage = {
          id: err.message.attachmentsReceived[0].cod,
          url: err.message.attachmentsReceived[0].base64,
          userType: 'message',
          isLoading: false,
          status: MessageStatus.ERROR
        }
        dispatch('$actionUpdateMessage', objMessage)
      } else {
        const objMessage = {
          id: success.message.attachmentsReceived[0].cod,
          url: success.message.attachmentsReceived[0].URL,
          userType: 'message',
          isLoading: false,
          status: MessageStatus.SUCCESS
        }
        dispatch('$actionUpdateMessage', objMessage)
      }
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
